/* Custom pure event delegation & .closest() functions.*/
EventTarget.prototype.delegateListener=function(b,c,d){let a=a=>{let b;[].slice.call(this.querySelectorAll(c)).reverse().filter(b=>b.contains(a.target)).forEach(c=>{(void 0===b|| !1!==b)&&(b=d.call(c,a))})};return this.addEventListener(b,a),a};function closest(a,b){do if(b(a))return a;while(a=a&&a.parentNode)}

window.Custom = window.Custom || {};

(function ($) {
  "use strict";

Custom = {
  container: document.querySelector(`body`),

  mobileBreakpoint: "868px",

  init: function() {
    // BASE
    this.setElementHeight();
    this.fontSize();
    this.setScrollAttributes();
    this.localizationPopup();

    if(document.querySelector('.sticky--button .button')) {
      
      document.querySelector('.sticky--button .button').addEventListener('click', function () {
        const targetElement = document.querySelector('[type="submit"].product-form__submit');
        console.log(targetElement);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    }
    
    document.querySelectorAll('[data-trigger]').forEach(button => {
        button.addEventListener('click', function () {
            const targetSelector = this.getAttribute('data-trigger');
            const targetElement = document.querySelector(targetSelector);
            if (targetElement) {
                targetElement.click();
            }
        });
    });

    window.off = Element.prototype.off = function(event) {
      if (!this.namespaces) { return }
      this.removeEventListener(event.split('.')[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    };
    
    window.on = Element.prototype.on = function(event, callback, options){
      if( !this.namespaces )
        this.namespaces = {};
  
      this.namespaces[event] = callback;
      options = options || false;
  
      this.addEventListener(event.split('.')[0], callback, options);
      return this;
    };
    
    this.iniDropdown();
  },

  closeAllPopups: function(current) {
    let popups = document.querySelectorAll(".popup--wrapper");
    popups.forEach((el) => {
      if(el !== current) {
        el.setAttribute("data-active", "false");
      }
      
    });
  },
  
  localizationPopup: function() {
    this.container.delegateListener("click", ".custom-localization button", function(e) {
      e.preventDefault();
      let _this = event.target.closest(".custom-localization");
      let popup = _this.querySelector(".popup--wrapper");
      
      this.closeAllPopups(popup);
      popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
    }.bind(this));

    this.container.delegateListener("click", ".custom-localization .popup--wrapper", function(e) {

      let _this = event.target;
      let popup = _this.closest(".custom-localization").querySelector(".popup--wrapper");

      if(!_this.closest(".popup--inner")) {
        popup.setAttribute("data-active", (popup.getAttribute("data-active") == "false"));
      }
    }.bind(this));
  },
  
  iniDropdown() {
    var selectors = {
      trigger: `[data-dropwdown="trigger"]`,
      module: `[data-dropwdown="body"]`,
      moduleInner: '.dropdown--inner',
      tabs: '.collapsible-trigger--tab'
    };
  
    var classes = {
      hide: 'hide',
      open: 'is-open',
      autoHeight: 'collapsible--auto-height',
      tabs: 'collapsible-trigger--tab'
    };
  
    var namespace = `.list--unset`;
  
    var isTransitioning = false;
  
    var el = document;
    el.querySelectorAll(selectors.trigger).forEach(trigger => {
      var state = trigger.classList.contains(classes.open);
      trigger.setAttribute('aria-expanded', state);
      trigger.off('click' + namespace);
      trigger.on('click' + namespace, toggle);
    });
    
    document.addEventListener("reload_dropdowns", function(event) {
      document.querySelectorAll(selectors.trigger).forEach(trigger => {
          var state = trigger.classList.contains(classes.open);
          trigger.setAttribute('aria-expanded', state);
          trigger.removeEventListener('click', toggle); // Remove previous event listener
          trigger.addEventListener('click', toggle); // Add event listener
      });
    });
    
    function toggle(evt) {
      if (isTransitioning) {
        return;
      }
  
      isTransitioning = true;
  
      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute('aria-controls');
      var container = document.getElementById(moduleId);
  
      if (!moduleId) {
        moduleId = el.dataset.controls;
      }
      
      if (!moduleId) {
        return;
      }
      
      if (!container) {
        var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
        }
      }
  
      if (!container) {
        isTransitioning = false;
        return;
      }
  
      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;
  
      if (isTab) {
        if(isOpen) {
          isTransitioning = false;
          return;
        }
  
        var newModule;
        document.querySelectorAll(selectors.tabs + '[data-id="'+ el.dataset.id +'"]').forEach(el => {
          el.classList.remove(classes.open);
          newModule = document.querySelector('#' + el.getAttribute('aria-controls'));
          setTransitionHeight(newModule, 0, true);
        });
      }
      
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }
  
      if (isOpen && !isAutoHeight) {
        height = 0;
      }
  
      el.setAttribute('aria-expanded', !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
        if(el.querySelector("span").textContent == "Read Less") {
          el.classList.remove("hide");
          el.querySelector("span").textContent = "Read More";
        }
      } else {
        el.classList.add(classes.open);
        if(el.querySelector("span").textContent == "Read More") {
          el.classList.add("hide");
          el.querySelector("span").textContent = "Read Less";
        }
      }
  
      setTransitionHeight(container, height, isOpen, isAutoHeight);
      
      if (parentCollapsibleEl) {
        var parentHeight = parentCollapsibleEl.style.height;
  
        if (isOpen && parentHeight === 'auto') {
          childHeight = 0;
        }
  
        var totalHeight = isOpen
                        ? parentCollapsibleEl.offsetHeight - childHeight
                        : height + parentCollapsibleEl.offsetHeight;
  
        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }
    }
  
    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      prepareTransition(container, function() {
        container.style.height = height+'px';
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });
  
      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function() {
          o.css('height','auto');
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    function prepareTransition(el, callback) {
      el.addEventListener('transitionend', removeClass);
  
      function removeClass(evt) {
        el.classList.remove('is-transitioning');
        el.removeEventListener('transitionend', removeClass);
      }
  
      el.classList.add('is-transitioning');
      el.offsetWidth;
  
      if (typeof callback === 'function') {
        callback();
      }
    }
  },
  
  getDistanceToParentBottom : function(element) {
    let elementRect = element.getBoundingClientRect();
    let parentRect = element.parentElement.getBoundingClientRect();
    let distanceToParentBottom = parentRect.bottom - elementRect.bottom;
    return distanceToParentBottom;
  },
  
  setElementHeight : function() {
    const elementHeight = (event) => {
      document.querySelectorAll("[data-height^='target']").forEach((el) => { 
        let container = el.closest("[data-height='container']");
        let name = el.getAttribute("data-height").split("/")[1];
        if(name) {
          document.documentElement.style.setProperty(`--${ name }`, el.clientHeight + "px");
        } else {
          container.style.setProperty('--element_height', el.clientHeight + 'px');
          if(!container.classList.contains("height-set")) {
            container.classList.add("height-set");
          }
        }
      });
      
    }
    window.addEventListener("resize", elementHeight);
    window.addEventListener("load", elementHeight);
  },

  setScrollAttributes: function() {  
    let lastScrollTop = 0;
    
    const handleScroll = (event) => {
      let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      this.container.setAttribute("data-scrollDirection", (currentScroll > lastScrollTop ? "down" : "up"));
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
      
      this.container.setAttribute("data-scrolled", window.scrollY > 0);
      
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("load", handleScroll);
  },

  setStickyElement: function(selector) {
    const elements = document.querySelectorAll(selector);
    let distance;
    
    this.checkScrollPosition(elements, this.header.clientHeight);
    window.addEventListener("scroll", () => {
      this.checkScrollPosition(elements, this.header.clientHeight);
    });
  },

  checkScrollPosition: (elements, header) => {
    let distance;
    let elementHeight;
    
    elements.forEach(function(element) {
      distance = window.pageYOffset + element.getBoundingClientRect().top;
      distance = element.getBoundingClientRect().top - header;
      elementHeight = element.clientHeight;

      element.style.paddingTop = distance <= 0 ? `${ elementHeight }px` : 0;
      element.setAttribute("data-sticky", distance <= 0);
    });
  },

  setInputValue: function(event, callback) {
    let self = event.target;
    let container = self.parentElement;
    let input = container.querySelector("input");
    let min = parseInt(input.getAttribute("min"));
    let current = parseInt(input.value);
    let max = parseInt(input.getAttribute("max"));

    input.value = self.classList.contains("plus") ? (current < max ? current + 1 : max) : (current > min ? current - 1 : min);

    if(self.classList.contains("minus") && current === min) {
      //callback(input.value);
    }

    callback(input.value);
    
    input.dispatchEvent(new Event('input', { 'bubbles': true }));
  },

  handlelize: function(str) {
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/([^\w]+|\s+)/g, '-')
      .replace(/\-\-+/g, '-')
      .replace(/(^-+|-+$)/g, '')
      .toLowerCase();
  
    return str
  },

  fontSize: function() {
    function adjustFontSize() {
      const elements = document.querySelectorAll('[data-font]');

      elements.forEach(element => {
        const elementWidth = element.offsetWidth;
        
        const fontData = element.getAttribute('data-font').split('/');
        const baseFontSize = parseFloat(fontData[0]) || 10;
        const baseContainerWidth = parseFloat(fontData[1]) || 1280;
        
        let newFontSize = (elementWidth / baseContainerWidth) * baseFontSize;

        if(newFontSize >= 16) {
          newFontSize = 16;
        }
        element.style.fontSize = newFontSize + 'px';
      });
    }

    window.addEventListener('load', () => {
      adjustFontSize();
      setTimeout(adjustFontSize, 1500);
      // setTimeout(adjustFontSize, 2000);
      setTimeout(adjustFontSize, 3000);
    });
                

    window.addEventListener('resize', adjustFontSize);
  }
};

Custom.init();

})();



class SliderElement extends HTMLElement {
  connectedCallback() {
    const settings = this.getAttribute('data-settings');
    const parsedSettings = settings ? JSON.parse(settings) : {};
    const arrowNextButtons = [];
    const arrowPrevButtons = [];

    const swiperContainer = this.querySelector('.swiper');

    const parentSection = this.closest('section');
    const paginationElement = parentSection ? parentSection.querySelector('.swiper-pagination') : null;
    const scrollbarElement = parentSection ? parentSection.querySelector('.swiper-scrollbar') : null;
    
    const nextButton = parentSection ? parentSection.querySelector('.swiper-button-next') : null;
    const prevButton = parentSection ? parentSection.querySelector('.swiper-button-prev') : null;
    
    if(nextButton && prevButton) {
      arrowNextButtons.push(nextButton);
      arrowPrevButtons.push(prevButton);
    }
    
    const defaultSettings = {
      loop: true,
      spaceBetween: 10,
      autoplay: {
        delay: 8000,
      },
      navigation: {
        nextEl: arrowNextButtons,
        prevEl: arrowPrevButtons,
      },
    };

    if (paginationElement) {
      defaultSettings.pagination = {
        el: paginationElement,
        clickable: true
      };
    }

    if(parsedSettings.thumbs) {
      parsedSettings.thumbs.swiper = parentSection.querySelector(".slider-thumbs .swiper");
    }
    
    if (scrollbarElement) {
      defaultSettings.scrollbar = {
        el: scrollbarElement
      };
    }
    
    console.log(defaultSettings, parsedSettings);
    
    const swiperSettings = { ...defaultSettings, ...parsedSettings };

    new Swiper(swiperContainer, swiperSettings);

    this.addDataIdClickHandler();
    // this.removeAttribute('data-settings')
  }

  
  addDataIdClickHandler() {
    
  }
}

customElements.define('slider-element', SliderElement);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-snippet='tooltip']").forEach(tooltipWrapper => {
    tooltipWrapper.addEventListener("mouseenter", () => 
      tooltipWrapper.setAttribute("data-active", "true")
    );

    tooltipWrapper.addEventListener("mouseleave", () => 
      tooltipWrapper.removeAttribute("data-active")
    );
  });
});

class BGGIntegration extends HTMLElement {
  static cache = {};
  static requestQueue = [];
  static isRequesting = false;

  connectedCallback() {
    const id = this.getAttribute("data-id");
    this.ratingElement = this.querySelector("span");

    if (!id || !this.ratingElement) return;

    this.loadGameRating(id);
  }

  async loadGameRating(gameId) {
    let ratings = this.getStoredRatings();

    if (ratings[gameId]) {
      this.ratingElement.textContent = ratings[gameId];
      this.ratingElement.classList.add("visible");
      return;
    }

    if (BGGIntegration.cache[gameId]) {
      this.ratingElement.textContent = BGGIntegration.cache[gameId];
      this.ratingElement.classList.add("visible");
      return;
    }

    BGGIntegration.requestQueue.push({ gameId, element: this });

    if (!BGGIntegration.isRequesting) {
      this.processQueue();
    }
  }

  async processQueue() {
    if (BGGIntegration.requestQueue.length === 0) {
      BGGIntegration.isRequesting = false;
      return;
    }

    BGGIntegration.isRequesting = true;
    const { gameId, element } = BGGIntegration.requestQueue.shift();

    const rating = await element.fetchGameRating(gameId);

    if (rating) {
      element.ratingElement.textContent = rating;
      this.ratingElement.classList.add("visible");
      let ratings = element.getStoredRatings();
      ratings[gameId] = rating;
      element.saveRatings(ratings);
      BGGIntegration.cache[gameId] = rating;
    } else {
      element.classList.add("hide");
    }

    setTimeout(() => {
      element.processQueue();
    }, 5000);
  }

  async fetchGameRating(gameId) {
    const proxyUrl = `https://api.allorigins.win/get?url=${encodeURIComponent(`https://boardgamegeek.com/xmlapi/boardgame/${gameId}&stats=1`)}`;

    try {
      const response = await fetch(proxyUrl);
      const data = await response.json();

      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data.contents, "text/xml");

      const averageRating = xmlDoc.querySelector("statistics ratings average")?.textContent;
      return averageRating ? parseFloat(averageRating).toFixed(1) : null;
    } catch (error) {
      console.error("Error fetching game data:", error);
      return null;
    }
  }

  getStoredRatings() {
    try {
      return JSON.parse(localStorage.getItem("bgg_ratings")) || {};
    } catch {
      return {};
    }
  }

  saveRatings(ratings) {
    localStorage.setItem("bgg_ratings", JSON.stringify(ratings));
  }
}

customElements.define("bgg-integration", BGGIntegration);
